//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "MobileInternationalEntry",
  data: function data() {
    return {
      bgImg: require("@/assets/home_bg/gjzq.png")
    };
  },
  computed: {
    cssVars: function cssVars() {
      return {
        "--mie-spacing": "16px",
        "--mie-radius": "12px",
        "--mie-height": "84px",
        "--mie-padding-x": "16px",
        "--mie-title-font-size": "20px",
        "--mie-desc-font-size": "11px",
        "--mie-shadow": "0 4px 14px 0 rgba(10, 61, 145, 0.18)"
      };
    }
  },
  methods: {
    goInternational: function goInternational() {
      this.$router.push("/international/home");
    }
  }
};